<div
  class="dropzone"
  dropzone
  (hovered)="toggleHover($event)"
  (dropped)="onDrop($event)"
  [class.hovering]="isHovering"
  [ngClass]="{ error: error !== '' }"
>
  <div class="d-flex">
    <div style="font-weight: 600">Drag Files here or &nbsp;</div>

    <div>
      <label>
        <a (mouseUp)="chooseFile.click()"
          ><span
            style="font-weight: 600; text-decoration: underline; color: #3b74b0"
            >choose from folder</span
          ></a
        >
        <input
          hidden
          type="file"
          (change)="onDrop($event.target.files)"
          accept="application/pdf"
          #chooseFile
        />
      </label>
    </div>
  </div>
</div>
